<template>
  <div class="message-list">
    <transition name="fade">
      <span v-if="scrollTop > 0" class="shadow"></span>
    </transition>
    <div id="message-list-scrollable" class="scrollable" @scroll="onScroll">
      <message v-for="message in messages" :key="message.id" :message="message" />
      <span ref="cursor" class="cursor"></span>
    </div>
  </div>
</template>

<script>
import _ from "underscore";

import Message from "@/components/message.vue";

export default {
  name: "MessageList",

  components: { Message },

  props: {
    messages: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      messagesCount: 0,
      scrollTop: 0,
      audio: new Audio("/static/click.mp3")
    };
  },

  watch: {
    messages: {
      handler(newValue) {
        if (newValue.length > this.messagesCount) {
          this.messagesCount = newValue.length;

          const cursor = this.$refs.cursor;
          const message = _.last(newValue);
          this.$nextTick(() => {
            this.$scrollTo(cursor, 500, {
              container: "#message-list-scrollable"
            });

            // #TODO check the message has already been seen.
            if (!message.customer_id) {
              this.audio.play();
            }
          });
        }
      },
      deep: true
    }
  },

  mounted() {
    this.$scrollTo(this.$refs.cursor, 500, {
      container: "#message-list-scrollable"
    });
  },

  methods: {
    onScroll(event) {
      this.scrollTop = event.target.scrollTop;
    }
  }
};
</script>
